/** Сколько страниц курсорного снимка читается за раз: список, история и строки поставки (дальше — отказ, а не обрезка). */
export const MAX_SNAPSHOT_PAGES = 50

/** Размер страницы курсора при чтении приходов поставки. */
export const RECEIPTS_PAGE_TAKE = 50

/** Предел длины номера поставки в запомненном намерении. */
export const MAX_SUPPLY_NUMBER_LENGTH = 64
